import React from 'react';
import SvgIcon from './SvgIcon';

const Panic = props => (
    <SvgIcon viewBox="0 0 17 16" {...props}>
        <defs>
            <path
                d="M15.7497208,12.2956419 L9.58363859,1.89045936 C8.87605539,0.703180212 7.10709739,0.703180212 6.39951419,1.89045936 L0.250279241,12.2956419 C-0.457303959,13.4994111 0.418751431,15 1.83391783,15 L14.1660822,15 C15.5812486,15 16.457304,13.4994111 15.7497208,12.2956419 Z M7.2,3.99768519 C7.2,3.625 7.55121951,3.33333333 8,3.33333333 C8.44878049,3.33333333 8.8,3.625 8.8,3.99768519 L8.8,8.8912037 C8.8,9.26388889 8.44878049,9.55555556 8,9.55555556 C7.55121951,9.55555556 7.2,9.26388889 7.2,8.8912037 L7.2,3.99768519 Z M8,12.6666667 C7.56129032,12.6666667 7.2,12.3154122 7.2,11.8888889 C7.2,11.4623656 7.56129032,11.1111111 8,11.1111111 C8.43870968,11.1111111 8.8,11.4623656 8.8,11.8888889 C8.8,12.3154122 8.43870968,12.6666667 8,12.6666667 Z"
                id="path-1"
            ></path>
        </defs>
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="map-tools" transform="translate(-1146.000000, -353.000000)">
                <g id="Group" transform="translate(1117.000000, 148.000000)">
                    <g id="PANIC" transform="translate(10.000000, 205.000000)">
                        <g id="panic" transform="translate(19.500000, 0.000000)">
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <use id="Panic" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-1"></use>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

Panic.displayName = 'PanicIcon';

export default Panic;
